// Tier 4 jobs - legendary tier. All cross-class, gated by very high T3
// jobMaxLv requirements + (artifact items / raid boss kills).
// See docs/03-jobs-skills §3.4, ADR 0005 §2.2, ADR 0006 §2.1.
//
// All growth bands follow the HHMLL pattern (sum_value = 5.0). The H pair
// covers the Type cores most central to the legendary identity. The Tier 4
// stat curve (Lmax=1300, tau=600) gives sustained growth even past Lv 800,
// so the same HHMLL placement yields larger raw stats than a T1 of the same
// Lv. ADR 0006 §2.1 / §2.2.
// --- Legitimate route (3 jobs, T3 jobMaxLv + quest) ---
export const JOB_SWORD_SAINT = {
    id: 'sword-saint',
    name: '剣聖',
    tier: 4,
    types: ['Tank', 'MeleeDPS'],
    // Same H/M/L as warrior/knight (G-WAR), but T4 curve scales much harder.
    growth: { str: 'high', dex: 'mid', int: 'low', vit: 'high', wis: 'low' },
    ultimateSkillId: 'ult.sword-saint.zero-domain',
};
export const JOB_GRAND_SAGE = {
    id: 'grand-sage',
    name: '大賢者',
    tier: 4,
    types: ['MagicDPS', 'Healer', 'Support'],
    // INT (MagicDPS) + WIS (Healer + Support core) covers all three Types.
    growth: { str: 'low', dex: 'mid', int: 'high', vit: 'low', wis: 'high' },
    ultimateSkillId: 'ult.grand-sage.cosmic-order',
};
export const JOB_ASTRAL_ARCHER = {
    id: 'astral-archer',
    name: '天弓聖',
    tier: 4,
    types: ['RangedDPS', 'Support', 'Summoner'],
    // DEX (RangedDPS + Support) + INT (Summoner) covers all three Types.
    growth: { str: 'low', dex: 'high', int: 'high', vit: 'low', wis: 'mid' },
    ultimateSkillId: 'ult.astral-archer.starfall',
};
// --- Special route (2 jobs, artifact-grade item + raid boss kill) ---
export const JOB_DARK_LORD = {
    id: 'dark-lord',
    name: '魔王',
    tier: 4,
    types: ['Tank', 'MagicDPS', 'Summoner'],
    // INT (MagicDPS + Summoner) + VIT (Tank) covers all three Types.
    growth: { str: 'low', dex: 'low', int: 'high', vit: 'high', wis: 'mid' },
    ultimateSkillId: 'ult.dark-lord.abyssal-throne',
};
export const JOB_SAINT = {
    id: 'saint',
    name: '聖者',
    tier: 4,
    types: ['Healer', 'Support', 'Tank'],
    // WIS (Healer + Support) + VIT (Tank) covers all three Types.
    growth: { str: 'low', dex: 'low', int: 'mid', vit: 'high', wis: 'high' },
    ultimateSkillId: 'ult.saint.aegis-covenant',
};
export const JOBS_TIER4 = [
    // Legitimate route (3)
    JOB_SWORD_SAINT,
    JOB_GRAND_SAGE,
    JOB_ASTRAL_ARCHER,
    // Special route (2)
    JOB_DARK_LORD,
    JOB_SAINT,
];
//# sourceMappingURL=tier4.js.map